import { AccountTypeEnum } from "./AccountTypeEnum";

export const OtherEmployerAccountType = [
  AccountTypeEnum.Governmental457bPlan,
  AccountTypeEnum.Plan403b,
  AccountTypeEnum.QualifiedRetirementPlan
];
